import { Injectable } from '@angular/core';
import { ConfigService } from './services/configService';

@Injectable()
export class AppInitializer {
    public constructor(
        private config: ConfigService,
    ) { }

    public Init() {
        return this.config.load().then(() => {
            return Promise.resolve(true);
        });
    }
}
